import { Capacitor } from '@capacitor/core';

/**
 * Request App Tracking Transparency authorization on iOS.
 * Returns the status string: 'authorized' | 'denied' | 'restricted' | 'notDetermined' | 'unrequested'.
 * On non-iOS platforms, resolves to 'authorized' (no-op).
 */
export async function requestTrackingPermission(): Promise<string> {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') {
    return 'authorized';
  }

  try {
    const { AppTrackingTransparency } = await import(
      'capacitor-plugin-app-tracking-transparency'
    );

    const { status } = await AppTrackingTransparency.getStatus();

    // Only show the dialog if the user hasn't been asked yet
    if (status === 'notDetermined') {
      const result = await AppTrackingTransparency.requestPermission();
      console.log('ATT permission result:', result.status);
      return result.status;
    }

    console.log('ATT status (already decided):', status);
    return status;
  } catch (error) {
    console.error('ATT request failed:', error);
    return 'notDetermined';
  }
}
